import React from "react";

const DescriptionProjet = ({
  formData,
  handleChange,
  inputFocus,
  handleTrimValue,
  page,
}) => {
  return (
    <div className="row mt-5">
      <div className="col-12 position-relative">
        <label className="form-label fw-bold" htmlFor="ProDescription">
          Veuillez donner une brève description de votre projet de changement
          d'usage <span className="text-danger">(facultatif)</span>&nbsp;:
        </label>
        <textarea
          className="form-control w-100 getLabel"
          name="ProDescription"
          id="ProDescription"
          maxLength={500}
          value={formData.ProDescription || ""}
          onChange={handleChange}
          onInput={inputFocus}
          onBlur={handleTrimValue}
          disabled={page === 5 ? true : false}
        ></textarea>
      </div>
    </div>
  );
};

export default DescriptionProjet;
